import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fetchReleasesErrorTitle: {
		id: 'business-calendar.controllers.calendar-releases-for-multi-projects.fetch-releases-error-title',
		defaultMessage: "We couldn't load your releases",
		description: 'Error message informing the user that the releases could not be fetched',
	},
	fetchReleasesErrorMessage: {
		id: 'business-calendar.controllers.calendar-releases-for-multi-projects.fetch-releases-error-message',
		defaultMessage: 'Refresh the page to try again.',
		description: 'Error message when fetching releases fails',
	},
});
